// Global supercoin balance state
let currentSupercoinBalance = 0

export const setSupercoinBalance = (balance: number) => {
    currentSupercoinBalance = balance
}

export const getSupercoinBalance = () => {
    return currentSupercoinBalance
}
